import { useIntl } from '@grandvisionhq/state';
import { formatDistance, DistanceUnit } from '@grandvisionhq/utils';
import { useStoreFinderContext } from '../context/StoreFinder/context.js';

const useDistanceUnit = (distance)=>{
    const { distanceUnit  } = useIntl();
    if (distanceUnit === DistanceUnit.meter || distanceUnit === DistanceUnit.km) {
        if (distance && distance < 1000) {
            return DistanceUnit.meter;
        }
    }
    return distanceUnit;
};
/**
 * @param distance
 * @returns returns a string that is the distance including unit and
 * appends "from you" indicator or similar defined on
 * appointments.component.storeFinderItem.distance label
 */ const useFormattedDistance = (distance)=>{
    const { userLocation , isUsingUserLocation  } = useStoreFinderContext();
    const { getFormattedLabel  } = useIntl();
    const distanceUnit = useDistanceUnit(distance);
    const distanceIncludingUnit = distance && formatDistance(distance, distanceUnit, {
        separator: ' '
    });
    if (!distanceIncludingUnit) {
        return undefined;
    }
    return userLocation !== undefined && isUsingUserLocation ? /* show `${distanceIncludingUnit} from you` indication otherwise show just the distance */ getFormattedLabel('appointments.component.storeFinderItem.distance', {
        labelData: {
            distance: distanceIncludingUnit
        }
    }) : distanceIncludingUnit;
};

export { useDistanceUnit, useFormattedDistance };
//# sourceMappingURL=use-formatted-distance.js.map
